'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function ROFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-hsd76ndam", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-hsd76ndam)" }, /* @__PURE__ */ React.createElement("path", { fill: "#fbcd17", d: "M10 0h12v24H10z" }), /* @__PURE__ */ React.createElement("path", { fill: "#e11c1b", d: "M22 0h10v24H22z" }), /* @__PURE__ */ React.createElement("path", { fill: "#2e42a5", d: "M0 0h10v24H0z" })))
  );
}

export { ROFlag };
//# sourceMappingURL=RO.mjs.map
